import { cn } from '@/lib/utils';
import { FunctionComponent } from 'react';
import SortButtons from '../sort/SortButtons';
import { DaasTableColumn } from './DaasTable';
import { SortDirection } from './sortHelper';

interface Props {
  header: DaasTableColumn;
  onSortCallback: (direction: SortDirection, subColumnId?: string) => void;
  sortDirection?: SortDirection;
  sortSubColumnId?: string;
  activeSort?: boolean;
}

const DaaSTableHeaderCell: FunctionComponent<Props> = ({
  header,
  onSortCallback,
  sortSubColumnId,
  sortDirection,
  activeSort = false
}) => {
  const getSortButtonStyles = (directionToStyle: SortDirection, subColumnId?: string) => {
    return cn(
      'p-0.5 rounded-full',
      sortDirection === directionToStyle && subColumnId === sortSubColumnId ? '!bg-[#2095A7] !text-white' : ''
    );
  };

  const hasSubHeaders = header.subHeaders && header.subHeaders.length > 0;

  return (
    <div
      key={header.accessor}
      className={cn(
        'border border-[#DDDDDD] flex items-center justify-between bg-gray-100 font-semibold',
        hasSubHeaders ? 'flex-col' : 'p-3'
      )}
    >
      <span className={cn(hasSubHeaders && 'w-full text-center py-3 border-b border-[#DDDDDD]')}>{header.text}</span>
      {hasSubHeaders ? (
        <div className="w-full flex [&>*:not(:last-child)]:border-r">
          {header.subHeaders!.map(subHeader => (
            <div
              key={subHeader}
              className="border-[#DDDDDD] flex flex-1 items-center px-3 py-2 justify-between bg-gray-100 font-semibold"
            >
              <span>{subHeader}</span>
              {header.sortable && (
                <div className="flex">
                  <SortButtons
                    onSortCallback={(direction: SortDirection) => {
                      onSortCallback(direction, subHeader);
                    }}
                    isActiveCallback={() => activeSort && subHeader === sortSubColumnId}
                    sortDirection={sortDirection}
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        header.sortable && (
          <div className="flex">
            <SortButtons
              onSortCallback={onSortCallback}
              isActiveCallback={() => activeSort}
              sortDirection={sortDirection}
            />
          </div>
        )
      )}
    </div>
  );
};

export default DaaSTableHeaderCell;
